export default {
// baseurl: "http://talentworld.dev-hi.xyz/api",
baseurl: "https://talentworld.netwave-tech.com/api",
};
